import type { SearchSitesParams } from "../../../../api/site/search";
import { AbstractPanel } from "../../../../common/abstractconditionpanel";
import hx from "../../../../utils/hydroxie";

/**
 * 観測点検索→検索条件エリア→地盤情報パネル
 */
export class SoilPanel extends AbstractPanel<SearchSitesParams> {
    /**
     * 初期化処理を行う。
     * 地盤情報の検索条件UI要素を生成し、イベントリスナーを設定する。
     */
    async init() {
        const elem = this.getElem();

        elem.replaceChildren(...this.#createElement());

        elem.addEventListener("change", () => {
            const params = this.#getParams();
            this.emit("update", params);
        });
    }

    #createElement() {
        return [
            hx("div", { className: "field" },
                hx("label", { className: "label" }, "表層30m平均S波速度 [m/s]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "avs30From" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "avs30To" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "VS1100上面深さ [m]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1100From" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1100To" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "VS1400上面深さ [m]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1400From" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1400To" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "VS1700上面深さ [m]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1700From" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d1700To" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "VS2100上面深さ [m]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d2100From" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "d2100To" }))),

            hx("div", { className: "field" },
                hx("label", { className: "label" }, "地震学的基盤面深さ [m]"),
                hx("div", { className: "control horizontal" },
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "dbaseFrom" }),
                    hx("span", "〜"),
                    hx("input", { type: "number", step: "any", min: "0", className: "input is-small", name: "dbaseTo" }))),
        ];
    }

    #getParams() {
        const avs30From = this.getNumber("[name='avs30From']");
        const avs30To = this.getNumber("[name='avs30To']");

        const d1100From = this.getNumber("[name='d1100From']");
        const d1100To = this.getNumber("[name='d1100To']");

        const d1400From = this.getNumber("[name='d1400From']");
        const d1400To = this.getNumber("[name='d1400To']");

        const d1700From = this.getNumber("[name='d1700From']");
        const d1700To = this.getNumber("[name='d1700To']");

        const d2100From = this.getNumber("[name='d2100From']");
        const d2100To = this.getNumber("[name='d2100To']");

        const dbaseFrom = this.getNumber("[name='dbaseFrom']");
        const dbaseTo = this.getNumber("[name='dbaseTo']");

        return {
            avs30From,
            avs30To,
            d1100From,
            d1100To,
            d1400From,
            d1400To,
            d1700From,
            d1700To,
            d2100From,
            d2100To,
            dbaseFrom,
            dbaseTo,
        };
    }
}
